var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rider_id",
    "data-name": "Rider id",
    transform: "translate(23 -21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    transform: "translate(-23 21)",
    fill: "none",
    stroke: "#00b26b",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun-contact-2884226",
    transform: "translate(-15 29.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M17.2,5H2.8A1.8,1.8,0,0,0,1,6.8v9.6a1.8,1.8,0,0,0,1.8,1.8H17.2A1.8,1.8,0,0,0,19,16.4V6.8A1.8,1.8,0,0,0,17.2,5ZM6.4,7.4A1.8,1.8,0,1,1,4.6,9.2,1.8,1.8,0,0,1,6.4,7.4Zm3,7.8a.6.6,0,0,1-.6.6H4a.6.6,0,0,1-.6-.6V13.4a1.8,1.8,0,0,1,1.8-1.8H7.6a1.8,1.8,0,0,1,1.8,1.8Zm4.8-.6h-3a.6.6,0,1,1,0-1.2h3a.6.6,0,1,1,0,1.2ZM16,12.2H11.2a.6.6,0,1,1,0-1.2H16a.6.6,0,1,1,0,1.2Z",
    transform: "translate(0)",
    fill: "#00b26b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCard);
export default __webpack_public_path__ + "static/media/ContactCard.836f9928aa089aeb9ec8080d8f31f83e.svg";
export { ForwardRef as ReactComponent };